var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{ref:"inputRef",staticClass:"input-custom",attrs:{"type":"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }